import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'

import LunaAssistContainer from '../lunaassist/lunaassist.container'
import BudgetContainer from '../widgets/budget/budget.container'
import ChatSidebarContainer from '../chat/chatsidebar.container'
import HistorySidebarContainer from '../history/history_sidebar.container'
import ContactContainer from '../contact/contact.container'

// import SettingsSidebarContainer from '../settings/settings_sidebar.container'
// import { ReservationsSidebar } from '../reservations/reservations_sidebar.component'
// import TeamSidebarContainer from '../team/team_sidebar.container'

export class AppFooter extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            unseenChats: 0,
            activeMenuItem: null
        }

        _.bindAll(this,
            'updateUnseenChats',
            'updateActiveMenuItem'
        )
    }

    updateActiveMenuItem(item) {
        if (this.state.activeMenuItem !== item) {
            this.setState({activeMenuItem: item})
        } else {
            this.setState({activeMenuItem: null})
        }
    }


    updateUnseenChats(newCount) {
        if (this.state.unseenChats !== newCount) {
            this.setState({unseenChats: newCount})
        }
    }

    render() {
        let overviewBtn = <div>&nbsp;</div>
        if (!this.props.isLunaTrip) {
            let notice = ''
            if (this.state.activeMenuItem !== 'chat' && this.state.unseenChats > 0) {
                if (this.state.unseenChats > 10) {
                    notice = <span className="menu-item-flag active">10+</span>
                } else {
                    notice = <span className="menu-item-flag active">{this.state.unseenChats}</span>
                }
            }

            if (this.props.activeLeg) {
                overviewBtn = <div className="btn btn-plain btn-flex" onClick={() => this.props.onActivateItinOverview()}>
                    <i className="icon-itinerary"/>Overview
                </div>  
            }

            if (window._isMobile) {
                return (
                    <div id="app-footer">
                        {overviewBtn}
                        <div className="widget-container">
                            <div className="widget-popup-wrapper">
                                <i className="icon-diamond" onClick={() => {this.updateActiveMenuItem('lunaassist')}}/>
                                <LunaAssistContainer updateActiveMenuItem={this.updateActiveMenuItem} activeMenuItem={this.state.activeMenuItem}/>
                            </div>
                            <div className="widget-popup-wrapper">
                                <i className="icon-receipt" onClick={() => this.props.onToggleBooking() }/>
                            </div>
                            <div className="widget-popup-wrapper">
                                <i className="icon-chat" onClick={() => {this.updateActiveMenuItem('chat')}}>
                                    {notice}
                                </i>
                                <ChatSidebarContainer updateUnseenChats={this.updateUnseenChats} updateActiveMenuItem={this.updateActiveMenuItem} activeMenuItem={this.state.activeMenuItem} mountedAt={this.state.mountedAt}/>
                            </div>
                            <div className="widget-popup-wrapper">
                                <i className="icon-menu" onClick={() => {this.updateActiveMenuItem('history')}}/>
                                <HistorySidebarContainer updateActiveMenuItem={this.updateActiveMenuItem} activeMenuItem={this.state.activeMenuItem}/>
                            </div>
                            <div className="widget-popup-wrapper">
                                <i className="icon-chat_help" onClick={() => {this.updateActiveMenuItem('contact')}}/>
                                <ContactContainer updateActiveMenuItem={this.updateActiveMenuItem} activeMenuItem={this.state.activeMenuItem}/>
                            </div>
                        </div>
                    </div>
                )  
            } else {
                return (
                    <div id="app-footer">
                        <BudgetContainer/>
                        <div id="luna-assist-trigger" className="widget-container">
                            <div className="widget-popup-wrapper">
                                <div className="btn" onClick={() => {this.updateActiveMenuItem('lunaassist')}}>LUNA ASSIST</div>
                                <LunaAssistContainer updateActiveMenuItem={this.updateActiveMenuItem} activeMenuItem={this.state.activeMenuItem}/>
                            </div>
                        </div>
                        <div className="widget-container">
                            <div className="widget-popup-wrapper">
                                <i className="icon-chat" onClick={() => {this.updateActiveMenuItem('chat')}}>
                                    {notice}
                                </i>
                                <ChatSidebarContainer updateUnseenChats={this.updateUnseenChats} updateActiveMenuItem={this.updateActiveMenuItem} activeMenuItem={this.state.activeMenuItem}/>
                            </div>
                            <div className="widget-popup-wrapper">
                                <i className="icon-menu" onClick={() => {this.updateActiveMenuItem('history')}}/>
                                <HistorySidebarContainer updateActiveMenuItem={this.updateActiveMenuItem} activeMenuItem={this.state.activeMenuItem}/>
                            </div>
                            <div className="widget-popup-wrapper">
                                <i className="icon-chat_help" onClick={() => {this.updateActiveMenuItem('contact')}}/>
                                <ContactContainer updateActiveMenuItem={this.updateActiveMenuItem} activeMenuItem={this.state.activeMenuItem}/>
                            </div>
                        </div>
                    </div>
                )  
            }
        } else {
            if (this.props.activeLeg) {
                overviewBtn = <div className="btn btn-plain btn-flex" onClick={() => this.props.onActivateItinOverview()}>
                    <i className="icon-itinerary"/>Overview
                </div>  
            }

            if (!window._isMobile) {
                overviewBtn = null
            }
            let lunaLink = '/create-trip?luna-slug=' + this.props.lunatrip.get('slug')
            return (
                <div id="app-footer">
                    {overviewBtn}
                    <div id="luna-trip-add" className="widget-container">
                        <a href={lunaLink} className="btn btn-rose" >Make this your trip</a>
                    </div>
                    <div className="widget-container">
                        <div className="widget-popup-wrapper">
                            <i className="icon-help" onClick={() => {this.updateActiveMenuItem('contact')}}/>
                            <ContactContainer updateActiveMenuItem={this.updateActiveMenuItem} activeMenuItem={this.state.activeMenuItem}/>
                        </div>
                    </div>
                </div>
            )    
        }
    }
}
